
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import {
  getRepairTemplate,
  setRepairTemplate
} from '@/api/system';
import { checkPermissionCompany, getModelPermission } from '@/utils/permission';
import { ViewType, Type, ModuleType } from '../../types/permissionType';
import { Qiniu } from '@/types/qiniu';
import { getQiniuToken } from '@/api/third';
import { makeKey } from '@/utils/qiniu';
import { batchSetRepairTemplate } from '@/api/branch';

@Component({
  name: 'SettingTemplateRepair',
  components: {

  }
})
export default class extends Vue {
  private activeTemplateName = 'quick'
  private rightShowIndex = 1
  private activeCustom = 'custom'
  private activeDevice = 'device'
  private defaultImgUrl = 'this.src="' + require('@/assets/images/default-avatar.png') + '"'

  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private imgData: any = {}
  private qiniu:any={}

  private formDevice: any = {
    children: '',
    logo: '',
    color: ''
  }

  // 数据项
  private templateSet:any = {
    order_brand_name: '品牌类型',
    order_customer_dept_name: '报修部门',
    order_customer_user_name: '申请人',
    order_fault_phenomenon_name: '故障现象',
    order_first_step: '0',
    order_mainaddress_name: '地址',
    order_mainaddress_type: '',
    order_name: '联系人',
    order_servicer_dept_name: '服务部门',
    order_subaddress_name: '详细地址',
    order_tags_name: '订单标签',
    order_template_type: '1',
    order_trouble_describe: '任务描述',
    order_device_sn: '设备编号',
    order_diy_one_content: '自定义1',
    order_diy_two_content: '自定义2',

    device_template_type: ''
  }
  // 权限
  private auth:any = {
    order_brand_name: false, // 品牌
    order_customer_dept_name: true, // 没有权限  一直都有
    order_customer_user_name: true, // 没有权限  一直都有
    order_fault_phenomenon_name: false, // 故障现象
    order_name: true, // 没有权限  一直都有
    order_servicer_dept_name: false, // 服务部门
    image: false, // 图片
    audio: false, // 音频
    order_subaddress_name: false, // 详细地址
    order_tags_name: false, // 订单标签
    order_trouble_describe: true, // 没有权限  一直都有
    customer_address: false, // 自定义地址
    address: false, // 省市区

    order_diy_one_content: true, // 自定义1
    order_diy_two_content: true // 自定义2
  }
 private Servicer:any=true;
 private isJump=false;
 created() {
   this.Servicer = checkPermissionCompany(UserModule.getCompanyId, Type.SERVICER_MODULE);
   if (this.Servicer) {
     this.activeTemplateName = 'quick';
   } else {
     this.activeTemplateName = 'selection';
     if (this.$route.query.branch_company_ids) {
       this.isJump = true;
     }
   }
   this.getData();
   this.initAuth();
   const params = {
     type: Qiniu.UPLOAD_TYPE_DEVICE
   };
   getQiniuToken(params).then(res => {
     if (res && res.data) {
       this.qiniu = res.data;
     }
   });
 }

 private initAuth() {
   this.auth.order_servicer_dept_name = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_DEPARTMENT).v === 1;
   this.auth.order_fault_phenomenon_name = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_FAULTPHENOMENON).v === 1;
   this.auth.order_tags_name = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_TAG).v === 1;
   this.auth.image = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_IMAGE).v === 1;
   this.auth.audio = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_AUDIO).v === 1;
   this.auth.order_brand_name = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_PRODUCT).v === 1;
   this.auth.customer_address = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_CUSTOM_ADDRESS).v === 1;
   this.auth.address = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_ADDRESS).v === 1;
   this.auth.order_subaddress_name = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_REPORT_ADDRESS_DETAIL).v === 1;
   this.auth.order_device_sn = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_SN).v === 1;
   this.auth.order_diy_one_content = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_DIY_ONE).v === 1;
   this.auth.order_diy_two_content = getModelPermission(ViewType.REPORT, 2, 0, UserModule.getCompanyId, ModuleType.ORDER_DIY_TWO).v === 1;
 }

 // 跳转到自定义地址设置页
 private goSettingTemplateAddress() {
   this.$router.push({
     path: 'address'
   });
 }
 private getData() {
   let params: any = {};
   params.user_id = UserModule.getUserId;
   params.company_id = UserModule.getCompanyId;
   getRepairTemplate(params)
     .then((res:any) => {
       if (res.data) {
         let temp = res.data;
         if (temp.order_brand_name) {
           this.templateSet.order_brand_name = temp.order_brand_name;
         }
         if (temp.order_customer_dept_name) {
           this.templateSet.order_customer_dept_name = temp.order_customer_dept_name;
         }
         if (temp.order_customer_user_name) {
           this.templateSet.order_customer_user_name = temp.order_customer_user_name;
         }
         if (temp.order_fault_phenomenon_name) {
           this.templateSet.order_fault_phenomenon_name = temp.order_fault_phenomenon_name;
         }
         if (temp.order_mainaddress_name) {
           this.templateSet.order_mainaddress_name = temp.order_mainaddress_name;
         }
         if (temp.order_name) {
           this.templateSet.order_name = temp.order_name;
         }
         if (temp.order_device_sn) {
           this.templateSet.order_device_sn = temp.order_device_sn;
         }
         if (temp.order_servicer_dept_name) {
           this.templateSet.order_servicer_dept_name = temp.order_servicer_dept_name;
         }
         if (temp.order_subaddress_name) {
           this.templateSet.order_subaddress_name = temp.order_subaddress_name;
         }
         if (temp.order_tags_name) {
           this.templateSet.order_tags_name = temp.order_tags_name;
         }
         if (temp.order_trouble_describe) {
           this.templateSet.order_trouble_describe = temp.order_trouble_describe;
         }
         if (temp.order_fault_type_name) {
           this.templateSet.order_fault_type_name = temp.order_fault_type_name;
         }
         if (temp.order_diy_one_content) {
           this.templateSet.order_diy_one_content = temp.order_diy_one_content;
         }
         if (temp.order_diy_two_content) {
           this.templateSet.order_diy_two_content = temp.order_diy_two_content;
         }
         this.templateSet.order_template_type = temp.order_template_type;
         this.templateSet.order_first_step = temp.order_first_step;
         this.templateSet.order_customer_type = temp.order_customer_type;
         this.templateSet.order_mainaddress_type = temp.order_mainaddress_type;
         if (parseInt(temp.order_first_step) === 6) {
           this.templateSet.device_template_type = temp.option_type && parseInt(temp.option_type) !== 0 ? temp.option_type : '';
         }
         this.formDevice.children = parseInt(temp.child_company_is_repair_device_template) === 1;
         this.formDevice.logo = temp.repair_device_template_style_image;
         this.formDevice.color = temp.repair_device_template_style_color;
       }
       // this.templateSet = res.data;
     })
     .catch((error:any) => {
       let msg = error.msg;
     });
 }

 // 设置默认报修模板
 private setingTemplateQuick() {
   let params: any = {};
   params.user_id = UserModule.getUserId;
   params.company_id = UserModule.getCompanyId;
   params.order_template_type = '1';
   params.order_customer_type = '1';
   setRepairTemplate(params)
     .then((res:any) => {
       this.showNext();
     })
     .catch((error:any) => {
       let msg = error.msg;
     });
 }

 // 设置自定义报修模板
 private setingTemplateCustom(val:any) {
   let params: any = {
     ...this.templateSet
   };
   params.user_id = UserModule.getUserId;
   params.company_id = UserModule.getCompanyId;
   setRepairTemplate(params)
     .then((res:any) => {
       this.showNext();
     })
     .catch((error:any) => {
       let msg = error.msg;
     });
 }

 // 设置个性样式
 private settingStyle() {
   let params: any = {};
   params.user_id = UserModule.getUserId;
   params.company_id = UserModule.getCompanyId;
   params.order_first_step = this.templateSet.order_first_step;
   setRepairTemplate(params)
     .then((res:any) => {
       this.showSuccessMsg('修改成功');
     })
     .catch((error:any) => {
       let msg = error.msg;
     });
 }

 // 下一步
 private showNext() {
   let _this = this;
   this.$confirm('模板应用成功。是否去设置个性化选择样式?', '提示', {
     confirmButtonText: '去设置',
     cancelButtonText: '取消',
     type: 'success'
   })
     .then(() => {
       _this.activeTemplateName = 'style';
     })
     .catch(() => {});
 }

 // 模板设置点击
 private editClick(index: any) {
   this.rightShowIndex = index;
 }

 // 设置个性样式 选择
 private radioClick(index: any) {
   this.templateSet.order_first_step = this.templateSet.order_first_step === index ? '0' : index;
 }

 // 报修选择样式
 private saveDeviceTemplate() {
   let params: any = {};
   params.user_id = UserModule.getUserId;
   params.company_id = UserModule.getCompanyId;
   params.order_first_step = 6;
   params.option_type = this.templateSet.device_template_type;
   params.repair_device_template_style_image = this.formDevice.logo;
   params.repair_device_template_style_color = this.formDevice.color;
   params.child_company_is_repair_device_template = this.formDevice.children ? '1' : '0';
   if (this.isJump) {
     params.branch_company_ids = this.$route.query.branch_company_ids;
     batchSetRepairTemplate(params)
       .then((res:any) => {
         this.showSuccessMsg('修改成功');
         this.$router.go(-1);
       })
       .catch((error:any) => {
         let msg = error.msg;
         this.showErrorMsg(msg);
       });
   } else {
     setRepairTemplate(params)
       .then((res:any) => {
         this.showSuccessMsg('修改成功');
       })
       .catch((error:any) => {
         let msg = error.msg;
         this.showErrorMsg(msg);
       });
   }
 }
 private handleSuccess(response:any) {
   this.formDevice.logo = response.key;
   // const imgUrl = this.qiniu.default_url + response.key;
   // let obj = {
   //   name: response.key,
   //   url: imgUrl
   // };
   // this.fileList.push(obj);
 }
 beforeUpload(file:any) {
   const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
   const isLt2M = file.size / 1024 / 1024 < 5;
   if (!isJPG) {
     return this.$message.error('上传文件只能是  JPG或PNG 格式!');
   }
   if (!isLt2M) {
     return this.$message.error('上传图片大小不能超过 5MB!');
   }
   return new Promise((resolve, reject) => {
     resolve(true);
   }).then(res => {
     let k = makeKey(this.qiniu.prekey);
     this.imgData = {
       key: k,
       token: this.qiniu.uptoken,
       domain: this.qiniu.domain
     };
   });
 }

 private showErrorMsg(msg: string) {
   this.$notify({
     title: '提示',
     message: msg,
     offset: 100,
     type: 'error'
   });
 }

 private showSuccessMsg(msg: string) {
   this.$notify({
     title: '提示',
     message: msg,
     offset: window.innerHeight * 0.4,
     customClass: 'notification-center',
     type: 'success'
   });
 }
}
